// 透過 @ay-nestjs/share 產生
/* eslint-disable */
import { PackageFetchForMessage } from '../package/dto/package-fetch-for-message.dto';
import { wsc } from '../wsc';
import { CreateMessageFolderDto } from './dto/create-message-folder.dto';
import { CreateMessageDto } from './dto/create-message.dto';
import { FetchMessageFolderResponseDto } from './dto/fetch-message-folder-response.dto';
import { FetchMessageUsedDto } from './dto/fetch-message-used.dto';
import { RenameMessageDto } from './dto/rename-message.dto';
import { UpdateMessageFolderDto } from './dto/update-message-folder.dto';
import { UpdateMessageDto } from './dto/update-message.dto';

export class MessageManagementModel {
  static createFolder(body: CreateMessageFolderDto): Promise<{ id: number }> {
    return wsc.execute('/ws/message-management/createFolder', body) as any;
  }

  static fetchFolders(): Promise<FetchMessageFolderResponseDto[]> {
    return wsc.execute('/ws/message-management/fetchFolders') as any;
  }

  static updateFolder(body: UpdateMessageFolderDto): Promise<any> {
    return wsc.execute('/ws/message-management/updateFolder', body) as any;
  }

  static deleteFolder(id: number): Promise<any> {
    return wsc.execute('/ws/message-management/deleteFolder', id) as any;
  }

  static create(body: CreateMessageDto): Promise<{
    id: number;
    name: string;
    packageId: number;
    folderId: number;
  }> {
    return wsc.execute('/ws/message-management/create', body) as any;
  }

  static rename(body: RenameMessageDto): Promise<any> {
    return wsc.execute('/ws/message-management/rename', body) as any;
  }

  static update(body: UpdateMessageDto): Promise<any> {
    return wsc.execute('/ws/message-management/update', body) as any;
  }

  static delete(id: number): Promise<any> {
    return wsc.execute('/ws/message-management/delete', id) as any;
  }

  static copy(id: number): Promise<any> {
    return wsc.execute('/ws/message-management/copy', id) as any;
  }

  static fetchPackage(messageId: number): Promise<PackageFetchForMessage> {
    return wsc.execute('/ws/message-management/fetchPackage', messageId) as any;
  }

  static fetchMessageUsed(messageId: number): Promise<FetchMessageUsedDto> {
    return wsc.execute(
      '/ws/message-management/fetchMessageUsed',
      messageId,
    ) as any;
  }
}
// af8717014cf45eef01476751215850f315048f76798c6c916f0053cc56ae600d
